import React, { Suspense } from "react";
import { Outlet } from "react-router";
import { Column, Row } from "@/shared/ui/Blocks";
import { Header } from "@/shared/widgets/Header";
import { Sidebar } from "@/shared/widgets/Sidebar";
import NavigationProvider from "@/shared/contexts/navigation.context";
import { RouteLoader } from "@/shared/ui/RouteLoader";
import { ReferencesProvider } from "../ReferencesDrawer/ReferencesContext";

function LayoutWithHeaderAndSidebar() {
  return (
    <NavigationProvider>
      <Column className="h-full">
        <Header />
        <Row className="relative flex-1 min-h-0">
          <Sidebar heightOffset={64} />
          <Suspense fallback={<RouteLoader />}>
            <ReferencesProvider>
              <Outlet />
            </ReferencesProvider>
          </Suspense>
        </Row>
      </Column>
    </NavigationProvider>
  );
}

export { LayoutWithHeaderAndSidebar };
